import { InteracBulkPayoutTransaction } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchInteracBulkPayoutTransaction({ bearer }: { bearer: string }) {
  const [fetching, setFetching] = useState(false);

  const [interacBulkPayoutTransaction, setInteracBulkPayoutTransaction] = useState<InteracBulkPayoutTransaction>();

  async function fetchInteracBulkPayoutTransaction(transactionID: string) {
    try {
      setFetching(true);
      const res = await api.fetchInteracBulkPayoutTransaction({ TransactionID: transactionID }, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setInteracBulkPayoutTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, interacBulkPayoutTransaction, fetchInteracBulkPayoutTransaction };
}
